// extracted by mini-css-extract-plugin
export default {"loader":"loder_loader__vHDRN","before8":"loder_before8__arBW7","after6":"loder_after6__FmI9X"};